import * as teamAction from './team-action'

export {
  teamAction,
}



// WEBPACK FOOTER //
// ./src/actions/team/index.js